import gql from "graphql-tag";

export const FILE_UPLOAD = gql`
  mutation SingleUpload($file: Upload!) {
    SingleUpload(file: $file) {
      filename
      url
      success
      message
    }
  }
`;

export const DELETE_FILE = gql`
  mutation DeleteFile($filename: String!) {
    DeleteFile(filename: $filename) {
      success
      message
      code
    }
  }
`;

export const GENERATE_PRESIGNED_URL = gql`
  query GENERATE_PRESIGNED_URL($filename: String!) {
    GeneratePresignedUrl(filename: $filename) {
      message
      success
      code
      url
    }
  }
`

